import { EuiLoadingSpinner } from '@equipmentshare/ds2'
import useInvoiceDetails from 'hooks/useInvoiceDetails'

export type InvoiceNumberProps= {
	targetId: number,
}

export default function InvoiceNumber( { targetId }: InvoiceNumberProps ) {
	const { loading, invoiceNo } = useInvoiceDetails( targetId )

	if ( loading ) {
		return <EuiLoadingSpinner />
	}

	if ( invoiceNo ) {
		return <span>INV-{invoiceNo}</span>
	}

	return <span>--</span>
}
